/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

export interface MembersForgotPasswordPut$Params {
  email: string;
  'CF-Connecting-IP'?: string;
}

export function membersForgotPasswordPut(
  http: HttpClient,
  rootUrl: string,
  params: MembersForgotPasswordPut$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, membersForgotPasswordPut.PATH, 'put');
  if (params) {
    rb.query('email', params.email, {});
    rb.header('CF-Connecting-IP', params['CF-Connecting-IP'], {});
  }

  return http
    .request(rb.build({ responseType: 'text', accept: '*/*', context }))
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({
          body: undefined,
        }) as StrictHttpResponse<void>;
      }),
    );
}

membersForgotPasswordPut.PATH = '/members/forgot-password';
